<template>
  <dropdown-menu
    v-model="show"
    interactive
    right
    class="datatable-dropdowns hidden sm:block"
  >
    <button class="toggle text-nowrap">
      Ordenamiento
      <span class="toggle-count" v-if="rules.length > 0">
        {{ rules.length }}
      </span>
    </button>
    <div slot="dropdown">
      <div class="dropdown-options">
        <div class="dropdown-options-container">
          <draggable
            tag="div"
            v-model="items"
            @change="onSortPriorityChange"
            animation="150"
            handle=".handle"
          >
            <span
              v-for="(item, index) in items"
              :key="index"
              class="dropdown-item handle"
              @click="onChangeOrdering(item)"
            >
                <span class="d-flex justify-content-between">
                  <i class="mdi clickable" :class="sortIcon(item)"></i>
                  <span class="dropdown-item-label w-100 pl-3 flex justify-content-between">
                    {{ item.label }}
                    <b-badge class="ml-3 flex align-items-center" variant="danger" v-if="showItemBadge(item)">{{ itemOrder(item) }}</b-badge>
                  </span>
                  <i class="mdi mdi-close clickable ml-2" v-if="isColumnAsRule(item)" @click.stop="onRemoveSortRule(item)"></i>
                </span>
            </span>
          </draggable>
        </div>
      </div>
    </div>
  </dropdown-menu>
</template>

<script>
import DropdownMenu from '@innologica/vue-dropdown-menu'
import draggable from 'vuedraggable'

export default {
  components: {
    DropdownMenu,
    draggable
  },
  props: {
    columns: {
      type: Array,
      default: () => []
    },
    defaultValue: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      show: false,
      items: [],
      rules: []
    }
  },
  methods: {
    getElasticKeyToSort (item) {
      // TODO. que pasa con las columnas que tienen mas de un elastic_key?
      // en datatables.config deberia haber una prop sorteableKey o por defecto toma la primera
      return item?.sortableKey || Object.values(item.elastic_key).at(0)
    },
    showItemBadge (item) {
      const key = this.getElasticKeyToSort(item)
      return this.rules.some(el => el.hasOwnProperty(key))
    },
    itemOrder (item) {
      const key = this.getElasticKeyToSort(item)
      return this.rules.findIndex(el => el.hasOwnProperty(key)) + 1
    },
    sortIcon (item) {
      const key = this.getElasticKeyToSort(item)
      const rule = this.rules.find(el => el.hasOwnProperty(key))
      if (rule) {
        if (rule[key] === 'asc') {
          return 'mdi-chevron-down'
        }
        return 'mdi-chevron-up'
      }
      return 'mdi-unfold-more-horizontal'
    },
    isColumnAsRule (item) {
      const key = this.getElasticKeyToSort(item)
      return this.rules.some(el => el.hasOwnProperty(key))
    },
    onRemoveSortRule (item) {
      const key = this.getElasticKeyToSort(item)
      const index = this.rules.findIndex(el => el.hasOwnProperty(key))
      this.rules.splice(index, 1)
      this.$emit('change', this.rules)
    },
    onSortPriorityChange (event) {
      const rules = []
      for (const item of this.items) {
        const key = this.getElasticKeyToSort(item)
        const rule = this.rules.find(el => el.hasOwnProperty(key))
        if (rule) {
          rules.push(rule)
        }
      }
      this.rules = rules
      this.$emit('change', this.rules)
    },
    onChangeOrdering (item) {
      const key = this.getElasticKeyToSort(item)
      let value = 'asc'
      // Si ya es una regla de ordenamiento
      const index = this.rules.findIndex(el => el.hasOwnProperty(key))
      if (index > -1) {
        value = this.rules.at(index)[key] === 'desc' ? 'asc' : 'desc'
        this.rules.splice(index, 1, { [key]: value })
      } else {
        this.rules.push({ [key]: value })
      }
      this.$emit('change', this.rules)
    }
  },
  created () {
  },
  mounted () {
    this.items = this.columns.filter(el => !el.primaryColumn && el.render === 'value')
    this.rules = this.defaultValue
  }
}
</script>
<style scoped>
.dropdown-options-container {
  z-index: 10000
}
.dropdown-item {
  padding: 0.22rem 0.6rem;
}
.dropup {
  position: absolute;
}
</style>
